/* eslint-disable no-sequences */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-unused-expressions */
/* eslint-disable func-names */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-rest-params */
/* eslint-disable no-undef */
/* eslint-disable global-require */
/* eslint-disable import/no-unresolved */


/**
 * Renders a modal window that will track the users consenting to accepting site tracking policy
 */

const executeGTM = () => {
    (function (w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
        const f = d.getElementsByTagName(s)[0];
        const j = d.createElement(s);
        const dl = l !== 'dataLayer' ? `&l=${l}` : '';
        j.async = true;
        j.src = `https://www.googletagmanager.com/gtm.js?id=${i}${dl}`;
        f.parentNode.insertBefore(j, f);
    }(window, document, 'script', 'dataLayer', 'GTMkey'));
    window.dataLayer = window.dataLayer || [];
    function gtag() {
        window.dataLayer.push(arguments);
    }
    gtag('js', new Date());
    gtag('config', 'GTMkey');
};

const executeGA = () => {
    (function (i, s, o, g, r, a, m) {
        i.GoogleAnalyticsObject = r;
        (i[r] = i[r] || function () {
            (i[r].q = i[r].q || []).push(arguments);
        }),
        (i[r].l = 1 * new Date());
        (a = s.createElement(o)),
        (m = s.getElementsByTagName(o)[0]);
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
    }(
        window,
        document,
        'script',
        'https://www.google-analytics.com/analytics.js',
        'GAID',
    ));
};

const executeGADS = () => {
    window.dataLayer = window.dataLayer || [];
    function gtag() { dataLayer.push(arguments); }
    gtag('js', new Date());
    gtag('config', 'GADS');
};

function addScript(src) {
    const s = document.createElement('script');
    s.setAttribute('src', src);
    s.async = true;
    return s;
}

function consentCTABarResponse(data) {
    if (data.ga) {
        const gaMethod = executeGA.toString().replace(/GAID/g, data.ga);

        $('#GAscript').append(`var gan = ${gaMethod}; gan();`);
    }

    if (data.gtm) {
        const processInclude = require('base/util');
        const gtmMethod = executeGTM.toString().replace(/GTMkey/g, data.gtm);

        $('#GTMscript').append(`var gtm = ${gtmMethod}; gtm();`);

        if ($('.product-tile').length > 0) {
            const categoryDatalayer = window.datalayerVersion === 'universal'
                ? require('plugin-seo/universalDataLayer/layers/category')
                : require('plugin-seo/dataLayerGA4/layers/category');

            processInclude(categoryDatalayer);
        }
        if ($('.payment-form').length > 0 || $('.payment-summary').length > 0) {
            const checkoutSuccessDatalayer = window.datalayerVersion === 'universal'
                ? require('plugin-seo/universalDataLayer/layers/checkout')
                : require('plugin-seo/dataLayerGA4/layers/checkout');

            processInclude(checkoutSuccessDatalayer);
        }
        if (data.url && data.url.indexOf('Product-Show') !== -1) {
            const prodViewDatalayer = window.datalayerVersion === 'universal'
                ? require('plugin-seo/universalDataLayer/layers/productView')
                : require('plugin-seo/dataLayerGA4/layers/productView');

            processInclude(prodViewDatalayer);
        } else if (data.url && data.url.indexOf('Order-Confirm') !== -1) {
            const checkoutSuccessDatalayer = window.datalayerVersion === 'universal'
                ? require('plugin-seo/universalDataLayer/layers/checkoutSuccess')
                : require('plugin-seo/dataLayerGA4/layers/checkoutSuccess');

            processInclude(checkoutSuccessDatalayer);
        }
    }

    if (data.gads) {
        const gadsUrl = `https://www.googletagmanager.com/gtag/js?id=${data.gads}`;
        const gadsScript = addScript(gadsUrl);
        const gtmMethod = executeGADS.toString().replace(/GADS/g, data.gads);
        $('#GADSscript').append(gadsScript);
        $('#GADSscript').append(`var gtm = ${gtmMethod}; gtm();`);
    }
}

module.exports = {
    consentCTABarResponse,
};
